export function adjustAngle(theta, min, max) {
    while (theta < min)
        theta += Math.PI * 2;
    while (theta > max)
        theta -= Math.PI * 2;
    return theta;
}
//# sourceMappingURL=adjustAngle.js.map